<template>
    <div>
        <VueMetaManager title="Primary Origin" />
        <router-view></router-view>
    </div>
</template>

<script>
export default {
  name: 'app',
  mounted() {
  },
};
</script>

<style lang="scss">
    // Import Main styles for this application
    @import "../sass/app";
</style>
